import React from 'react';
import { FollowToggleIcon } from '../FollowToggleIcon';
import { FollowingText, FollowText } from './consts';
import { FollowButtonTooltipWrapper } from './FollowButtonTooltipWrapper';
import { Button, ButtonText } from './styles';
import { defaultButtonColor, defaultButtonSize, FollowButtonProps } from './types';

export const FollowButton: React.FC<FollowButtonProps> = (props) => {
  const {
    className,
    color = defaultButtonColor,
    followingColor,
    iconOnly,
    isAnimated,
    isFollowing,
    name,
    onClick,
    showNameOnButton,
    showUnfollowTooltip,
    size = defaultButtonSize,
  } = props;

  const hasName = !!name;
  const button = (
    <Button
      className={className}
      color={color}
      followingColor={followingColor}
      iconOnly={iconOnly}
      isFollowing={isFollowing}
      onClick={onClick}
      size={size}>
      <FollowToggleIcon isAnimated={isAnimated} followingColor={followingColor} isFollowing={isFollowing} />
      {!iconOnly && (
        <ButtonText>
          {isFollowing ? FollowingText : FollowText}
          {hasName && showNameOnButton && ` ${name}`}
        </ButtonText>
      )}
    </Button>
  );
  return showUnfollowTooltip ? (
    <FollowButtonTooltipWrapper isFollowing={isFollowing} name={name}>
      {button}
    </FollowButtonTooltipWrapper>
  ) : (
    button
  );
};
